import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import { goToPage , reportDWH } from '../../GenericWizardBlockSlice';
import { createMemo } from '../../GenericWizardBlockThunk';
import Config from '../../../../../Config';


const ErrorPage = (props) => {

    useEffect(() => {
        props.createMemo();
        props.reportDWH({ actionType: 'SupportStepGuide', status: 'Completed', messageText: 'Service Needed Page Displayed' })
    }, []);

    function handleOnClickButton(){
        buildUrlAndOpenSameWindow(props.errorPage.buttonLink);
    }

    function handleOnClickCallBackButton(){
        props.goToPage({page: 'callBackPage'});
    }

    return (
        <div className="error-page">
            <div className='content'>
                <div className='img-error'>
                    <Image src={ Config.epiBaseUrl + props.errorPage.icon} alt='error-icon' />
                </div>
                {props.errorPage.title && <div className='title' dangerouslySetInnerHTML={{ __html: props.errorPage.title }}></div>}
                {props.errorPage.subTitle && <div className='sub-title' dangerouslySetInnerHTML={{ __html: props.errorPage.subTitle }}></div>}
                {props.isDisplayCallBack && <BtnWhiteBlackBorderBigSize text='קבלת שיחה חוזרת מנציג' onclick={() => {handleOnClickCallBackButton();}}/>}
            </div>
            <div className='button-wrapper'>
                   <BtnWhiteBlackBorderBigSize
                        text={props.errorPage.buttonText}
                        onclick={() => {
                            handleOnClickButton();
                        }}
                    />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        errorPage: state.genericWizardBlock.epiBlockData.errorPage,
        isDisplayCallBack : state.genericWizardBlock.epiBlockData.isDisplayCallBack
    };
};

const mapDispatchToProps = { goToPage, createMemo, reportDWH };

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
